/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, HFlow, Icon, Text, Theme } from 'bold-ui'
import { AccordionButton } from 'components/accordion/AccordionButton'
import theme from 'config/theme'
import { useMemo } from 'react'
import { Accordion, AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'
import { MetaPath } from 'util/metaPath'

import AvaliacaoDesenvolvimentoTable from '../components/AvaliacaoDesenvolvimentoTable'
import { AvaliacaoDesenvolvimentoModel } from '../model'

interface MarcoFormSectionAccordionProps {
  name: MetaPath<AvaliacaoDesenvolvimentoModel[]>
}

export function MarcoFormSectionAccordion(props: MarcoFormSectionAccordionProps) {
  const { name } = props
  const classes = useMemo(() => createStyles(theme), [])
  return (
    <Accordion allowZeroExpanded>
      <Grid>
        <Cell size={6}>
          <AccordionItem uuid='15-primeiros-dias'>
            <AccordionButton style={classes.button} wrapperStyle={classes.wrapperButton}>
              <HFlow alignItems='center'>
                <Icon icon='angleDown' size={1.5} />
                <Text component='span' fontWeight='bold'>
                  15 primeiros dias
                </Text>
              </HFlow>
            </AccordionButton>
            <AccordionItemPanel>
              <AvaliacaoDesenvolvimentoTable name={name} />
            </AccordionItemPanel>
          </AccordionItem>
        </Cell>
      </Grid>
    </Accordion>
  )
}
const createStyles = (theme: Theme) => ({
  button: css`
    display: flex;
    padding: 0.75rem 1.5rem;
    border: 1px ${theme.pallete.divider} solid;
    background-color: ${theme.pallete.gray.c90};
    margin: 0;
    position: relative;
  `,
  wrapperButton: css`
    padding-bottom: 0;
  `,
})
